import styled from 'styled-components';

export const SessionYearMonthSelectWrapper = styled.div`
  display: flex;
  gap: 8px;

  .session-year-month-select_year {
    width: 110px;
  }

  .session-year-month-select_month {
    width: 90px;
  }
`;
